import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SilobagDashboardInfoData } from './silobag-dashboard-info.types';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: getSilobagsDashboardInformation_DEPRECATED

// implementado ✅
export async function silobagDashboardInfoService() {
  const { organizationId } = useGlobalStore.getState();
  const query = transformIntoQueryParamString({ organization_id: organizationId });
  const { response, data } = await BACKEND.get<SilobagDashboardInfoData>(ENDPOINT.DASHBOARD_SILOBAGS, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
